// Node_modules
import { DeliveryLayoutContext } from "Providers";
import { FC, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext, CaseContext } from "Stores";
import { TileSidebarMenuItem } from "../../TileSidebarMenuItem";

export const QuestionAnswerTile: FC = () => {

    // Context
    const { caseState } = useContext(CaseContext);
    const { authState } = useContext(AuthContext);
    const { isRightSidebarCollapsed, setIsOnRightSidebarHoverCollapsed,
        isOnRightSidebarHoverCollapsed } = useContext(DeliveryLayoutContext);

    const isTileShown = authState.hasAccessToDynamicDelivery && caseState.isDynamicDelivery;

    // We get history to navigate
    const history = useHistory();

    const onQuestionAnsweringClick = () => {
        const url = `/cases/${caseState.selectedCaseId}/delivery/search/questionanswering`;
        history.replace(url);
    };

    if(!isTileShown) return null;
    return (
        <TileSidebarMenuItem
            id="question-answering-tile"
            text={"Question Answering"}
            onClickHandler={onQuestionAnsweringClick}
            imageUrl={"/images/tileQuestionAnswering.png"}
            isOnRightSidebarHoverCollapsed={isOnRightSidebarHoverCollapsed}
            setIsOnRightSidebarHoverCollapsed={setIsOnRightSidebarHoverCollapsed}
            isCollapsedSidebarRight={isRightSidebarCollapsed}
            handleRightSidebarHoveringCollapse={true}
            isNewFeature={true}>
        </TileSidebarMenuItem>
    );
};